import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { LoginData, LoginRequest } from "@/types/Auth/login";
import type { PasswordChangeRequest } from "@/types/Auth/password";

export async function Auth(payload: LoginRequest) {
  const { data } = await apiClient.post<ApiResponse<LoginData>>(
    "/api/v1/admin/login",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Login failed");
  }

  return data;
}

export async function Logout(payload: { adminId: string }) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/v1/admin/logout",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Logout failed");
  }

  return data;
}

export async function UpdatePassword(payload: PasswordChangeRequest) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/v1/admin/change_password",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Change password failed");
  }

  return data;
}